import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';

@Injectable()
export class VeiculoFrequenteService extends ServiceCRUD {

  private baseUrlService: string;
  public carregando = true;

  constructor(
    public httpClient: HttpClient,
    router: Router,
    protected toastr: ToastrService
  ) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/veiculo_frequente`;
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
    });
  }

  /**
   * Os parametros data_inicial e data_final foram removidos: a consulta
   * usa sempre a janela fixa de 90 dias, aplicada no backend.
   */
  public getDados(
    dealers?: any,
    numeroChassi?: any
  ): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService}/veiculo_frequente/`, {
      headers: this.getHeaders(),
      params: new HttpParams()
        .set('dealers', dealers ? dealers.toString() : '')
        .set('numeroChassi', numeroChassi ? numeroChassi.toString() : '')
    });
  }

  /**
   * Marca o chassi como iniciado. O backend recusa se ja estiver marcado.
   */
  public marcarIniciado(numeroChassi: string, numeroOs: string): Observable<any> {
    return this.httpClient.post<any>(
      `${this.baseUrlService}/veiculo_frequente/iniciar`,
      null,
      {
        headers: this.getHeaders(),
        params: new HttpParams()
          .set('numeroChassi', numeroChassi)
          .set('numeroOs', numeroOs ? numeroOs.toString() : '')
      }
    );
  }

  /**
   * Marca o chassi como finalizado. O backend recusa se ja estiver marcado.
   */
  public marcarFinalizado(numeroChassi: string, numeroOs: string): Observable<any> {
    return this.httpClient.post<any>(
      `${this.baseUrlService}/veiculo_frequente/finalizar`,
      null,
      {
        headers: this.getHeaders(),
        params: new HttpParams()
          .set('numeroChassi', numeroChassi)
          .set('numeroOs', numeroOs ? numeroOs.toString() : '')
      }
    );
  }

  /**
   * Inclui uma observacao. As anteriores nao sao alteradas nem removidas.
   */
  public incluirObservacao(numeroChassi: string, numeroOs: string, texto: string): Observable<any> {
    return this.httpClient.post<any>(
      `${this.baseUrlService}/veiculo_frequente/observacao`,
      texto,
      {
        headers: this.getHeaders(),
        params: new HttpParams()
          .set('numeroChassi', numeroChassi)
          .set('numeroOs', numeroOs ? numeroOs.toString() : '')
      }
    );
  }

  /**
   * Historico de acompanhamento de um chassi.
   */
  public buscarHistorico(numeroChassi: string): Observable<any> {
    return this.httpClient.get<any>(
      `${this.baseUrlService}/veiculo_frequente/historico`,
      {
        headers: this.getHeaders(),
        params: new HttpParams().set('numeroChassi', numeroChassi)
      }
    );
  }

  /**
   * Todos os acompanhamentos ja registrados, para a segunda extracao.
   * Sem filtro de data: alcanca chassis fora dos 90 dias.
   */
  public listarAcompanhamentos(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.baseUrlService}/veiculo_frequente/acompanhamentos`,
      { headers: this.getHeaders() }
    );
  }
}